import React, { useState, useEffect, useContext } from 'react';
import { useForm } from 'react-hook-form';
import Layout from '../components/Layout';
import Button from '../components/Button';
import Steps from '../components/StepsReturning';
import Back from '../components/Back';
import { GlobalContext } from '../reducers/global';
import Measurement from '../components/Measurement';
import langs from '../translations/langs';

const ReturnSetp1 = ({ setPage }) => {
    const {
        state: {
            measurements: { values },
            options: { measurementSystem, language },
        },
        dispatch,
    } = useContext(GlobalContext);

    const [measurements, setMeasurements] = useState(values);
    const { step3 } = langs[language];

    const onSubmit = () => {
        setPage('returningResults');
    };

    useEffect(() => {
        dispatch({
            type: 'MEASUREMENTS_SET',
            values: measurements.map((val, index) => {
                const measureDate = new Date(Date.parse(val.date));
                return {
                    date: val.date,
                    dateYYYY: measureDate.getFullYear(),
                    dateMM: measureDate.getMonth(),
                    dateDD: measureDate.getDate(),
                    height: val.height,
                    heightFt: val.heightFt,
                    heightIn: val.heightIn,
                    weight: val.weight,
                    weightSt: val.weightSt,
                    weightLb: val.weightLb,
                    selected: index === 0,
                };
            }),
        });
    }, [measurements, dispatch, measurementSystem]);

    const { register, handleSubmit, errors } = useForm();

    const renderMeasurements = measurements.map((_, index) => {
        const current = [...measurements];
        return (
            <>
                <Measurement
                    measurementSystem={measurementSystem}
                    index={index}
                    state={measurements}
                    setState={setMeasurements}
                    register={register}
                    errors={errors}
                />
                {index !== 0 && (
                    <Button
                        text={step3.removeButton}
                        onClick={() => {
                            current.splice(index, 1);
                            setMeasurements(current);
                        }}
                    />
                )}
            </>
        );
    });

    return (
        <Layout>
            <Back
                onClick={() => {
                    setPage('returningUser');
                }}
            />
            <Steps current={2} />
            <h3>{step3.title}</h3>
            <form className="form" onSubmit={handleSubmit(onSubmit)}>
                {renderMeasurements}

                <div className="column-1">
                    <Button
                        buttonStyle="secondary"
                        text={step3.previousButton}
                        onClick={() => {
                            setMeasurements([...measurements, {}]);
                        }}
                    />
                    <p>{step3.previousText}</p>
                </div>

                <Button text={step3.nextButton} type="submit" />
            </form>
        </Layout>
    );
};

export default ReturnSetp1;
